import React, { useState, useEffect } from 'react';

const ScrollUpButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPx = document.documentElement.scrollTop;
            const maxScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            setScrollProgress(maxScroll > 0 ? Math.min((scrollPx / maxScroll) * 100, 100) : 0);
            setIsVisible(scrollPx > 150);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

    const r = 22;
    const circ = 2 * Math.PI * r;
    const offset = circ - (scrollProgress / 100) * circ;

    return (
        <button
            onClick={scrollToTop}
            title="Yukarı çık"
            className={`fixed bottom-6 right-6 z-[90] w-14 h-14 rounded-full flex items-center justify-center
                bg-white/20 backdrop-blur-sm shadow-md shadow-black/10
                shadow-[0_0_0_0_rgba(212,175,55,0)]
                hover:shadow-[0_0_0_4px_rgba(212,175,55,0.15),0_8px_24px_rgba(0,0,0,0.6)]
                transition-all duration-500
                group
                ${isVisible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-10 pointer-events-none'}
            `}
        >
            {/* Progress ring */}
            <svg
                className="absolute inset-0 w-full h-full -rotate-90"
                viewBox="0 0 56 56"
            >
                {/* Track */}
                <circle cx="28" cy="28" r={r} fill="none" stroke="#222" strokeWidth="2" />
                {/* Progress */}
                <circle
                    cx="28"
                    cy="28"
                    r={r}
                    fill="none"
                    stroke="#D4AF37"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeDasharray={circ}
                    strokeDashoffset={offset}
                    className="transition-[stroke-dashoffset] duration-150 ease-out"
                    style={{ filter: 'drop-shadow(0 0 4px rgba(212,175,55,0.7))' }}
                />
            </svg>

            {/* Arrow icon */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="relative z-10 w-5 h-5 text-[#D4AF37] transition-all duration-300 group-hover:text-white group-hover:-translate-y-0.5 group-hover:drop-shadow-[0_0_6px_rgba(212,175,55,0.9)]"
            >
                <line x1="12" y1="20" x2="12" y2="4" />
                <polyline points="6 10 12 4 18 10" />
            </svg>
        </button>
    );
};

export default ScrollUpButton;
